export const paymentFaqStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [{
    '@type': 'Question',
    name: 'What does a Direct Debit payment cost?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'Stripe charges 1% with a 20p minimum. ShuttleOps charges the same amount separately. Pro and Extra group weekly session charges into one monthly transaction. The final cost depends on payment size and timing.',
    },
  }],
};
